<div class="flex justify-content-center align-items-center text-xl font-bold" *ngIf="onExtendedMobile()">
	{{ 'SITES_MANAGEMENT' | translate }}
</div>
<div class="layout-content px-2 pt-3" [ngClass]="layoutMarginResponsive()">
	<!-- FILTER -->
	<app-sites-cards-filters 
		[siteFilters]="siteFilter"
		[siteType]="siteType"
		[isImpers]="isImpersMode"
		(createSiteClicked)="createSite()"
		>
	</app-sites-cards-filters>
	<!-- CONTENT -->
	<div class="grid" [class]="onTablet() ? 'flex justify-content-center px-2' : ''">
		<div *ngFor="let site of sitesOrder" [class]="onExtendedMobile() ? 'w-full' : 'mx-2'">
			<!-- MOBILE -->
			<app-site-card-mobile *ngIf="onExtendedMobile()" [site]="site"></app-site-card-mobile>

			<!-- DESKTOP -->
			<app-site-card-desktop-tablet *ngIf="!onExtendedMobile()" [site]="site"></app-site-card-desktop-tablet>
		</div>
	</div>
</div>